import CommercialSections from './CommercialSections';
import CommercialHealthchecks from './CommercialHealthchecks';
import { getProjectManager, HEALTHCHECK_NAMES } from 'domain/shared/newProject';
import BaseControl from '../BaseControl';
import { resolveControlsZone } from '../utils';
import { ControlData } from '../types';

type CommercialControlProps = {
  data: ControlData;
  refetchControlsData: () => Promise<unknown>;
  showSections?: boolean;
};

export const commercialHealthcheckNames = [
  HEALTHCHECK_NAMES.PROJECT_COMMERCIAL_STATE,
  HEALTHCHECK_NAMES.ASSUMPTIONS,
  HEALTHCHECK_NAMES.CONTRACT_RENEWAL,
  HEALTHCHECK_NAMES.BUDGET_STATE,
  HEALTHCHECK_NAMES.BILLING,
  HEALTHCHECK_NAMES.COMMERCIAL_RISKS,
] as const;

const CommercialControl = ({ data, refetchControlsData, showSections = true }: CommercialControlProps) => {
  const projectManager = getProjectManager(data);
  const zone = resolveControlsZone({
    healthChecks: data?.health?.healthChecks,
    healthcheckNames: [...commercialHealthcheckNames],
  });

  return (
    <BaseControl
      title="Commercial"
      controlResponsible={projectManager}
      zone={zone}
      healthchecks={<CommercialHealthchecks data={data} refetchControlsData={refetchControlsData} />}
      sections={showSections ? <CommercialSections data={data} refetchControlsData={refetchControlsData} /> : null}
    />
  );
};
export default CommercialControl;
